export const estimateSelectionTypes = {
  TOGGLE_ESTIMATE_SELECTION: 'TOGGLE_ESTIMATE_SELECTION',
  CLEAR_SELECTED_ESTIMATES: 'CLEAR_SELECTED_ESTIMATES',
  SET_SELECTED_ESTIMATES: 'SET_SELECTED_ESTIMATES',
  SET_ASSIGN_MULTIPLE_MODAL_OPEN: 'SET_ASSIGN_MULTIPLE_MODAL_OPEN',
  SET_ASSIGN_MULTIPLE_LOADING: 'SET_ASSIGN_MULTIPLE_LOADING',
}

export interface ToggleEstimateSelectionAction {
  type: typeof estimateSelectionTypes.TOGGLE_ESTIMATE_SELECTION
  payload: string
}

export interface ClearSelectedEstimatesAction {
  type: typeof estimateSelectionTypes.CLEAR_SELECTED_ESTIMATES
  payload: null
}

export interface SetSelectedEstimatesAction {
  type: typeof estimateSelectionTypes.SET_SELECTED_ESTIMATES
  payload: string[]
}

export interface SetAssignMultipleModalOpenAction {
  type: typeof estimateSelectionTypes.SET_ASSIGN_MULTIPLE_MODAL_OPEN
  payload: boolean
}

export interface SetAssignMultipleLoadingAction {
  type: typeof estimateSelectionTypes.SET_ASSIGN_MULTIPLE_LOADING
  payload: boolean
}

export type EstimateSelectionAction = ToggleEstimateSelectionAction | ClearSelectedEstimatesAction | SetSelectedEstimatesAction | SetAssignMultipleModalOpenAction | SetAssignMultipleLoadingAction

export interface EstimateSelectionState {
  selectedEstimates: string[]
  assignMultipleModalOpen: boolean
  assignMultipleLoading: boolean
}
